import * as React from 'react'
import PropTypes from 'prop-types'
import './alert.css'


export default class extends React.Component<any, any>{

    static propTypes = {
        show: PropTypes.bool
    }


    static defaultProps = {
        show: true
    }


    render(){
        return this.props.show
        ? <div className="card">{ this.props.children }</div>
        : null
    }

}


// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/common/components/alert.tsx